import React, { Component } from 'react';
import styled from 'styled-components';

import { SettingsIcon } from 'components/Common';
import PermissionWarningIcon from 'components/Permissions/WarningIcon';

import { translations } from 'i18n';

import iOSInstalledCheck from 'inline-icons/ios-installed-check.svg';
import App from '../../../models/app';
import { AppCard } from '../AppCard';
import StateManagementButton from '../StateManagementButton/index';

const RightItem = styled.div`
  padding: 0 5px;
`;

const RightButton = styled(RightItem)`
  color: #01b1ba;
`;

const InstalledIconContainer = styled.div`
  background-image: url(${({ theme }) => theme.InstalledCheck});
  height: 16px;
  width: 18px;
  -webkit-transform: translateZ(0);
`;

const InstalledIcon = () => (
  <InstalledIconContainer
    dangerouslySetInnerHTML={{
      __html: iOSInstalledCheck
    }}
  />
);

interface AppDigestProps {
  app: App;
  showInstalled?: boolean;
  showSettings?: boolean;
  showUpdate?: boolean;
  onRemove?: (app: App) => void;
  showPermissionWarning?: boolean;
  collectionId?: string;
}

export class AppDigest extends Component<AppDigestProps> {

  onRemove = (ev: any) => {
    const { app, onRemove } = this.props;
    if (ev) {
      ev.preventDefault();
    }
    if (onRemove) {
      onRemove(app);
    }
  };

  onSettingsClick = (ev: any) => {
    ev.preventDefault();
    const { app } = this.props;
    app.navigateToSettings();
  };

  renderRightItem() {
    const {
      app,
      showInstalled,
      showSettings,
      showUpdate,
      showPermissionWarning
    } = this.props;
    const {
      page: {
        App: { InstallButtonState }
      }
    } = translations;

    if (showUpdate && (app.hasUpdateAvailable || app.isInstalling)) {
      const installTexts = Object.keys(InstallButtonState).reduce(
        (texts: any, key) => {
          texts[key] = InstallButtonState[key]();
          return texts;
        },
        {}
      );
      return (
        <RightItem>
          <StateManagementButton app={app} texts={installTexts} />
        </RightItem>
      );
    }

    if (showInstalled && app.isInstalledOrInstalling) {
      return (
        <RightButton>
          <InstalledIcon />
        </RightButton>
      );
    }

    if (showPermissionWarning && app.hasPermissionWarning) {
      return (
        <RightItem>
          <PermissionWarningIcon />
        </RightItem>
      );
    }

    if (showSettings && app.hasSettings) {
      return (
        <RightButton onClick={this.onSettingsClick}>
          <SettingsIcon />
        </RightButton>
      );
    }
  }

  render() {
    const { app, collectionId } = this.props;

    return (
      <AppCard
        id={app.id}
        screenshot={app.isTile? app.banners[0] : app.icon}
        name={app.name}
        rating={app.ratingSummary}
        appStatus={this.renderRightItem()}
        showRatings={app.showRatings}
        isPremium={app.isPremium}
        collectionId={collectionId}
        appType={app.type}
      />
    );
  }
}
